const MODAL_CLICK = 'MODAL_CLICK';

export default MODAL_CLICK;
